module.exports = __webpack_public_path__ + "static/media/samosa.8ff96462.jpg";